import React from 'react';

const WelcomeInfoPane = () => {
  return (
    <>
      <h2 className="text-2xl font-semibold">
				Welcome to OncoLens <span className="italic">Collaborate</span>!
      </h2>
      <p className="mt-2">
				Developed to extend multidisciplinary care beyond tumor board discussions. OncoLens{' '}
        <span className="italic">Collaborate</span> provides direct access to cancer specialists and
				disease-site experts to ensure patients have access to the best care, regardless of their
				physical location.
      </p>
    </>
  );
};

export { WelcomeInfoPane as default };
